import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const requestPath = '/api/v4/master/delete_all/places';

export const useDeleteAllPlacesMutation = () => {
  const queryClient = useQueryClient();

  return {
    post: useMutation({
      mutationFn: () => axios.post(requestPath),

      // 呼び出し側は DataGrid のキー（usePlacesRequest）しか無効化していないため、
      // フォームの地点候補が読む ['places']（useQueryPlaces）はここで無効化する。
      onSuccess: () => queryClient.invalidateQueries({ queryKey: ['places'] }),
    }),
  };
};
